<template lang="pug">

.card.card-xl-stretch.mb-xl-8
  .card-header.border-0.pt-5
    h3.card-title.align-items-start.flex-column
      span.card-label.fw-bolder.fs-3.mb-1 Equipe relacionada
      span.text-muted.fw-bold.fs-7 40 participantes
    .card-toolbar
      button.btn.btn-light.btn-active-light-primary.btn-sm(type='button', data-kt-menu-trigger='click', data-kt-menu-placement='bottom-end')
        | Ver todos
  .card-body.py-3
    .table-responsive
      table.table.align-middle.gs-0.gy-5
        thead
          tr
            th.p-0.w-50px
            th.p-0.min-w-200px
            th.p-0.min-w-40px
        tbody
          template(v-for='person in team', :key='person.id')
            tr
              th
                .symbol.symbol-50px.me-2
                  span.symbol-label
                    img.h-50.align-self-center(src='/metronic8/demo1/assets/media/svg/brand-logos/plurk.svg', alt='')
              td
                a.text-dark.fw-bolder.text-hover-primary.mb-1.fs-6(href='#')
                  | {{ person.name }}
                span.text-muted.fw-bold.d-block.fs-7
                  | {{ person.permission }}
              td.text-end
                a.btn.btn-light.btn-active-light-primary.btn-sm(href='#')
                  | Editar

</template>

<script>
export default {
  name: "RelatedTeam",

  props: {
    team: { type: Array, required: true },
  },
};
</script>

<style></style>
